import React from 'react'
import styles from '../style.module.less'

export default [
  {
    title: '案例',
    dataIndex: 'cover_path',
    render: (cover_path, { title }) => (
      <div className={styles.clearfix}>
        <img src={cover_path + '?imageView2/1/w/80/h/40'} />
        <p>{title}</p>
      </div>
    )
  },
  {
    title: '收藏数',
    dataIndex: 'collectors_count'
  },
  {
    title: '上架时间',
    dataIndex: 'updated_at',
    render: updated_at => [
      <p>{updated_at && updated_at.split(' ')[0]}</p>,
      <p>{updated_at && updated_at.split(' ')[1]}</p>
    ]
  }
]
